<!--
新闻详情页 - 上下翻页
-->
<template>
  <div :class="$style.page">
    <div v-if="prev" :class="$style.page_item">
      <nuxt-link :to="`/${parent}/${prev.id}`">
        <span :class="$style.page_label">上一篇</span>
        <span v-if="parent === 'news'" :class="$style.page_img">
          <img :src="prev.thumb || require('./images/poster.jpg')" />
        </span>
        <span :class="$style.page_title">
          <i>{{ prev.title }}</i>
        </span>
      </nuxt-link>
    </div>
    <div v-if="next" :class="$style.page_item">
      <nuxt-link :to="`/${parent}/${next.id}`">
        <span :class="$style.page_label">下一篇</span>
        <span v-if="parent === 'news'" :class="$style.page_img">
          <img :src="next.thumb || require('./images/poster.jpg')" />
        </span>
        <span :class="$style.page_title">
          <i>{{ next.title }}</i>
        </span>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    prev: {
      type: Object,
      default: null,
    },
    next: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['current']),
    parent() {
      return this.current.name
    },
  },
}
</script>

<style lang="less" module>
.page {
  width: 3.67rem;

  &_item {
    a {
      display: inline-flex;
      flex-direction: column;
      text-decoration: none;
    }

    &:last-child:not(:first-child) {
      margin-top: 0.8rem;
    }
  }

  &_label {
    margin-left: 0.01rem;
    padding-left: 0.16rem;
    border-left: 0.03rem solid @primary;
    font-size: 16px;
    color: #494949;
  }

  &_img {
    margin-top: 0.4rem;
    margin-left: 0.19rem;

    img {
      .size(3.48rem, 1.92rem);
    }
  }

  &_title {
    display: inline-flex;
    align-items: center;
    margin-top: 0.2rem;
    margin-left: 0.19rem;
    color: @text-color;

    &::before {
      .size(3px);
      content: '';
      display: block;
      margin-left: 2px;
      margin-right: 0.5em;
      border: 0.02rem solid @primary;
      transform: rotate(45deg);

      a:hover & {
        background-color: @primary;
      }
    }

    i {
      display: block;
      max-width: 3.4rem;
      font-style: normal;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

      a:hover & {
        color: @primary;
        text-decoration: underline;
      }
    }
  }

  @media screen and (max-width: @laptop-width) {
    &_label {
      font-size: 14px;
    }
  }

  // mini 尺寸下纯文字排版
  @media screen and (max-width: @mini-width) {
    width: auto;

    &_item {
      &:last-child:not(:first-child) {
        margin-top: 0.8em;
      }

      a {
        flex-direction: row;
        line-height: 1.5;
      }
    }

    &_label {
      padding-left: 0;
      border-left: 0;
      white-space: nowrap;

      &::after {
        content: '：';
      }
    }

    &_img {
      display: none;
    }

    &_title {
      margin-top: 0;
      margin-left: 0;

      &::before {
        content: none;
      }

      i {
        max-width: none;
        text-overflow: initial;
        white-space: normal;
      }
    }
  }
}
</style>
